export function isChromiumBased(ua: string): boolean {
  if (/Firefox\//i.test(ua)) return false;
  if (/Edg\//.test(ua)) return true;
  if (/OPR\/|Opera/i.test(ua)) return true;
  if (/CriOS\//.test(ua)) return true;
  if (/Chrome\//.test(ua) || /Chromium\//.test(ua)) return true;
  return false;
}

export function detectChromiumBrowser(ua = navigator.userAgent): boolean {
  return isChromiumBased(ua);
}
